/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    DownloadTemplate() {
        return HttpService.get(environment.API_IMPORT_DEPARTMENT + `/template`, {
            responseType: 'blob',
        });
    },
    DownloadTemplateId(id) {
        return HttpService.get(
            environment.API_IMPORT_DEPARTMENT + `/history/${id}`,
            { responseType: 'blob' }
        );
    },
    UploadDepartment(payload, onUploadProgress) {
        return HttpService.post(
            environment.API_IMPORT_DEPARTMENT + `/template`,
            payload,
            {
                onUploadProgress,
                headers: {
                    'Content-Type': 'multipart/form-data; charset=utf-8',
                },
            }
        );
    },
    ImportHistory(params) {
        return HttpService.get(environment.API_IMPORT_DEPARTMENT + `/history`, {
            params,
        });
    },
};
